import * as React from 'react';
// styles/components/seasonal-content-hub/'
// eslint-disable-next-line
const GTM_CONTAINER_ID = 'GTM-TFBT53CP';

export function AmpAnalyticsScript() {
    return (
        <script
            async={true}
            custom-element="amp-analytics"
            src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
        ></script>
    );
}

export function AmpAnalytics() {
    return (
        <amp-analytics
            config={`https://www.googletagmanager.com/amp.json?id=${GTM_CONTAINER_ID}&gtm.url=SOURCE_URL`}
            data-credentials="include"
        ></amp-analytics>
    );
}
